import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StandardButtonComponent } from "../standard-button/standard-button.component";
import { ModalWrapperComponent } from "../modal-wrapper/modal-wrapper.component";
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-update-modal',
  standalone: true,
  imports: [StandardButtonComponent, NgIf, ModalWrapperComponent, MatIconModule],
  templateUrl: './update-modal.component.html',
  styleUrl: './update-modal.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UpdateModalComponent {
	readonly dialogRef = inject(MatDialogRef<UpdateModalComponent>);
	readonly type = inject<string>(MAT_DIALOG_DATA);

	constructor() {}

	update() {
		const platform = Capacitor.getPlatform();
		
		// URL de la tienda según la plataforma
		let storeUrl = '';
		
		if (platform === 'android') {
			// Google Play Store
			storeUrl = 'https://play.google.com/store/apps/details?id=com.metaeducation.gotalks&hl=es_PE';
		} else if (platform === 'ios') {
			// App Store - Reemplazar con el ID real cuando esté disponible
			storeUrl = 'https://apps.apple.com/app/gotalks/idXXXXXXXXXX';
		}
		
		if (storeUrl) {
			// Abrir la tienda
			window.open(storeUrl, '_system');
		}
		
		this.dialogRef.close();
	}

	later() {
		this.dialogRef.close();
	}
}
